'use strict';
import React from 'react';
import {DataLoader, SubDataLoader} from "../../components/Input";
const { getLabel } = OptionUtils;

// 班別工作時間 (am10020)
class AMShiftPicker extends DataLoader {
	static defaultProps = {
	   ... DataLoader.defaultProps,
	   api: bid => `/api/am/options/${bid}/shifts`,
	   placeholder: '班別',
	};
	static label(value, defaultLabel, bid, render, _class, mate, textLabel) {
		render = textLabel ? (d => <>{d.name}</>) : render || (d => <><small className="extra">{d.code}</small>{d.name}</>);
		return DataLoader.label(value, defaultLabel, bid, render, 'AMShiftPicker');
	}

	static brief(value, bid, _class, field = 'shiftAbbrName') {
		return AMShiftPicker.text(value, bid, _class, field);
	}

	componentDidMount(){
		super.componentDidMount();

		const { mntAct } = this.props;
		if (mntAct) mntAct(this);
	}
}

// 班別工作時間 (am10020) 簡稱版
class AMShiftAbbrPicker extends AMShiftPicker {
	static defaultProps = {
		...AMShiftPicker.defaultProps,
		renderTag: d1 => d1.shiftAbbrName,
		renderItem: d2 => <>{d2.code && <span className="extra">{d2.code}</span>}{d2.shiftAbbrName}</>,
		renderItemText: d3 => <>{d3.shiftAbbrName}</>,
		isCache: false,
	};
	static label(...a1) {
		a1[3] = d3 => <><small className="extra">{d3.code}</small>{d3.shiftAbbrName}</>;
		return AMShiftPicker.label(...a1);
	}
	//僅顯示文字及停用標示
	static labelText(...a1) {
		a1[3] = d3 => <>{d3.shiftAbbrName}</>;
		return AMShiftPicker.label(...a1);
	}
	static text(...a2) {
		a2[3] = 'shiftAbbrName';
		return AMShiftPicker.text(...a2);
	}
	static data(...a3) { return AMShiftPicker.data(...a3); }
	static fetch(...a4) {
		a4[0] = AMShiftPicker.defaultProps;
		return AMShiftPicker.fetch(...a4);
	}
	getValue() {
		const vv = super.getValue();
		return vv || (this.props.mntAct ? -1 : vv);
	}

	getText() {
		if (!this.props.mntAct)
			return super.getText();
		return this._picker?.getText() || this.props.label;
	}
}

// 班別規則 (am10025)
class AMLateRulePicker extends DataLoader{
	static defaultProps = {
		... DataLoader.defaultProps,
		api: '/api/am/options/lateRules',
		placeholder: '班別規則'
	};
}

// 排班規則
class AMSaRulePicker extends DataLoader{
	static defaultProps = {
		... DataLoader.defaultProps,
		api: '/api/am/options/saRules',
		placeholder: '排班規則'
	};
}

// 時段班別規則
class AMSectionRulePicker extends DataLoader{
	static defaultProps = {
		... DataLoader.defaultProps,
		api: '/api/am/options/sectionRules',
		placeholder: '時段班別規則'
	};
}

// 時數人員規則
class AMAttendRulePicker extends DataLoader{
	static defaultProps = {
		... DataLoader.defaultProps,
		api: '/api/am/options/attendRules',
		placeholder: '時數人員規則'
	};
}

// 一般假規則 (am10110)
class AMLeavePicker extends DataLoader{
	static defaultProps = {
		... DataLoader.defaultProps,
		api: '/api/am/options/leaves',
		placeholder: '假勤項目'
	};
}

// 特休假規則 (am10130)
class AMAnnualPicker extends DataLoader{
	static defaultProps = {
		... DataLoader.defaultProps,
		api: '/api/am/options/annuals',
		placeholder: '特休假規則'
	};
}

// 公司假規則 (am10131)
class AMCoAnnualPicker extends SubDataLoader{
	static defaultProps = {
		... SubDataLoader.defaultProps,
		api: '/api/am/options/coAnnuals',
		placeholder: '公司假規則 ...',
	};
}

// 彈性假規則 (am10140)
class AMFlexiblePicker extends SubDataLoader{
	static defaultProps = {
		... SubDataLoader.defaultProps,
		api: '/api/am/options/flexibles',
		placeholder: '彈性假規則 ...',
	};
}

// 加班類別 (am10210)
class AMOtTypePicker extends DataLoader{
	static defaultProps = {
		... DataLoader.defaultProps,
		api: '/api/am/options/otTypes',
		placeholder: '加班類別'
	};
}

// 加班規則 (am10220)
class AMOtRulePicker extends DataLoader{
	static defaultProps = {
		... DataLoader.defaultProps,
		api: '/api/am/options/otRules',
		placeholder: '加班規則'
	};
}

// 特殊日倍率 (am10230)
class AMOtSpecPicker extends DataLoader {
	static defaultProps = {
		...DataLoader.defaultProps,
		api: '/api/am/options/otSpecs',
		placeholder: '特殊日倍率',
	};
}

// 超時出勤原因 (am10250)
// 記得加filter:  v => v.type && v.active(針面後台ＨＲ處理)
class AMAttendPicker extends DataLoader {
	static defaultProps = {
		...DataLoader.defaultProps,
		api: '/api/am/options/attends',
		placeholder: '超時出勤原因',
	};
}

// 工時規則 (am10310)
class AMOtWorkHourPicker extends DataLoader{
	static defaultProps = {
		... DataLoader.defaultProps,
		api: '/api/am/options/otWorkHours',
		placeholder: getLabel('components.EmpUtils', 'workRules'),
	};
}

// 行事曆清單 (am10050)
class AMCalendarPicker extends DataLoader{
	static defaultProps = {
		... DataLoader.defaultProps,
		api: '/api/am/options/calendars',
		placeholder: '行事曆',
	};
	static label(value, defaultLabel, bid){
		return DataLoader.label(value, defaultLabel, bid, d => <><span className="extra">{d.code}</span>{d.name}</>, 'AMCalendarPicker');
	}
}

// 假節日規則 (am10060)
class AMHolidayRulePicker extends DataLoader{
	static defaultProps = {
		... DataLoader.defaultProps,
		api: '/api/am/options/holidayRules',
		placeholder: '假節日規則'
	};
}

// 行事曆類別 (am10070)
class AMCalendarLeavePicker extends DataLoader{
	static defaultProps = {
		... DataLoader.defaultProps,
		api: '/api/am/options/calendarLeaves',
		placeholder: '假節日類型'
	};
}

// 刷卡鐘 (am10410)
class AMClockPicker extends DataLoader{
	static defaultProps = {
		... DataLoader.defaultProps,
		api: '/api/am/options/clocks',
		placeholder: '刷卡鐘'
	};
}

// GPS打卡 (am10440)
class AMGPSPicker extends DataLoader{
	static defaultProps = {
		... DataLoader.defaultProps,
		api: '/api/am/options/gps',
		placeholder: 'GPS打卡位置'
	};
}

// 網路打卡 (am10450)
class AMIPPicker extends DataLoader{
	static defaultProps = {
		... DataLoader.defaultProps,
		api: '/api/am/options/ip',
		placeholder: '網路打卡位置'
	};
}

// Wi-Fi打卡 (am10460)
class AMWifiPicker extends DataLoader{
	static defaultProps = {
		... DataLoader.defaultProps,
		api: '/api/am/options/wifi',
		placeholder: 'Wi-Fi打卡位置'
	};
}

// 排班群組 (am10610)
class SAGroupPicker extends DataLoader {
	static defaultProps = {
		...DataLoader.defaultProps,
		api: '/api/am/options/group', placeholder: '排班群組',
	};
}

// 排班標籤 (am10620)
class AMWorkLabelPicker extends DataLoader{
	static defaultProps = {
		... DataLoader.defaultProps,
		api: '/api/am/options/workLabel',
		placeholder: '排班標籤',
		filter: d => d.active && d.defLabel,
	};
}

// 發佈設定 (am10630)
class AMPostSettingsPicker extends DataLoader{
	static defaultProps = {
		... DataLoader.defaultProps,
		api: '/api/am/options/postSettings',
		placeholder: '發佈設定'
	};
}

// 國定假日挪移 (am10650)
class AMHolidayAdjPicker extends DataLoader{
	static defaultProps = {
		... DataLoader.defaultProps,
		api: '/api/am/options/holidayAdj',
		placeholder: '複製國定假日挪移',
	};
}

export {
	AMShiftPicker, AMSaRulePicker, AMShiftAbbrPicker,
	AMSectionRulePicker, AMAttendRulePicker,
	AMLeavePicker, AMAnnualPicker, AMCoAnnualPicker, AMFlexiblePicker,
	AMOtTypePicker, AMOtRulePicker, AMOtSpecPicker, AMAttendPicker, AMOtWorkHourPicker,
	AMCalendarPicker, AMHolidayRulePicker, AMCalendarLeavePicker,
	AMLateRulePicker, AMClockPicker, AMGPSPicker, AMIPPicker, AMWifiPicker,
	SAGroupPicker, AMWorkLabelPicker, AMPostSettingsPicker, AMHolidayAdjPicker,
};
